import { DepositFormData } from "../types/deposit";

export const formatDepositAmount = (type: string, amount: number): string => {
  if (type === "Fixed Amount") {
    return `$${amount.toFixed(2)}`;
  } else if (type === "Percentage") {
    return `${amount}%`;
  }
  return `${amount}`;
};

export const validateDepositForm = (
  data: DepositFormData,
): { isValid: boolean; errors: Record<string, string> } => {
  const errors: Record<string, string> = {};

  if (!data.name?.trim()) {
    errors.name = "Name is required";
  }

  if (!data.type) {
    errors.type = "Type is required";
  }

  if (!data.amount || data.amount <= 0) {
    errors.amount = "Amount must be greater than 0";
  }

  if (data.type === "Percentage" && data.amount > 100) {
    errors.amount = "Percentage cannot exceed 100%";
  }

  if (!data.salon_service_ids || data.salon_service_ids.length === 0) {
    errors.services = "At least one service must be selected";
  }

  return {
    isValid: Object.keys(errors).length === 0,
    errors,
  };
};

export const groupServicesByType = (services: any[]): Record<string, any[]> => {
  return services.reduce(
    (groups, service) => {
      const type = service.service_type || "Other";
      if (!groups[type]) {
        groups[type] = [];
      }
      groups[type].push(service);
      return groups;
    },
    {} as Record<string, any[]>,
  );
};
